import React from "react";

const RTFRPricing = ({ title, descriptionMain, rows = [], descriptionNote }) => {
  return (
    <section className="rtfr-pricing-section">
      <div className="container">
        <h2
          className="rtfr-pricing-title text-center"
          data-aos="fade-up"
          data-aos-once="true"
        >
          {title}
        </h2>

        <p
          className="rtfr-pricing-main"
          data-aos="fade-up"
          data-aos-delay="100"
          data-aos-once="true"
        >
          {descriptionMain}
        </p>

        <div
          className="table-responsive"
          data-aos="fade-up"
          data-aos-delay="150"
          data-aos-once="true"
        >
          <table className="rtfr-pricing-table">
            <thead>
              <tr>
                <th>Tonnage Tier</th>
                <th>Daily Without Driver</th>
                <th>Daily With Driver</th>
                <th>Weekly</th>
                <th>Monthly</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => (
                <tr key={i}>
                  <td><strong>{row.tier}</strong></td>
                  <td>{row.dailyWithout}</td>
                  <td>{row.dailyWith}</td>
                  <td>{row.weekly}</td>
                  <td>{row.monthly}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div
          className="rtfr-pricing-note-box"
          data-aos="fade-up"
          data-aos-delay="200"
          data-aos-once="true"
        >
          <p>{descriptionNote}</p>
        </div>

        <div
          className="rtfr-pricing-actions"
          data-aos="fade-up"
          data-aos-delay="300"
          data-aos-once="true"
        >
          <a href="tel:+971544792905" className="mini-btn primary">
            Call Now
          </a>
          <a
            href="https://wa.me/971544792905"
            target="_blank"
            rel="noopener noreferrer"
            className="mini-btn secondary-dark"
          >
            WhatsApp Now
          </a>
        </div>
      </div>
    </section>
  );
};

export default RTFRPricing;
